<template>

    <div class="main">
        <!-- 頁首 -->
        <Header :title="title" :isBack="true" />

        <!-- 主體 -->
        <div class="mainContent">

            <!-- 智慧農場 -->
            <div class="agri-result-group pwa pb-1">
                <b-container>

                    <!-- 示範場域 -->
                    <!-- 標題 -->
                    <PwaTitle v-if="false" :textTitle="wisdom_farm.title" :showMore="false"></PwaTitle>
                    <div v-if="false" class="">
                        <!-- 輪播 -->
                        <carousel
                            :key="wisdom_farm.list.length"
                            :autoplay="false" :margin="10" :loop="false" :nav="false" :dots="false" :responsive="{0:{items: 3},768:{items: 3},992:{items: 4}}" v-if="wisdom_farm.list.length > 0 ">
                            <div v-for="(item, index) in wisdom_farm.list" :key="index">
                                <div @click="setWisdomFarmSelect(item)" class="agri-result-item drop-shadow">
                                    <!-- 相片 -->
                                    <div class="agri-result-pic">
                                        <b-img :src="item.src"  fluid></b-img>
                                    </div>
                                    <!-- 標題 -->
                                    <div class="agri-result-info">
                                        <h3 class="agri-result-title">{{ item.title }}</h3>
                                    </div>
                                </div>
                            </div>
                        </carousel>
                    </div>
                    <!-- 資料來源網址 -->
                    <DataSource v-if="false" :href="wisdom_farm.source.href" :text="wisdom_farm.source.title"></DataSource>

                    <!-- 智慧農業成果 -->
                    <!-- 標題 -->
                    <PwaTitle :textTitle="wisdom_agri.title" :showMore="false"></PwaTitle>
                    <div class="wisdom-carousel" v-if="wisdom_agri.list.length > 0"
                        @touchstart="onAgriTouchStart"
                        @touchend="onAgriTouchEnd"
                        @mousedown="onAgriMouseDown"
                        @mouseup="onAgriMouseUp"
                    >
                        <!-- 滑動軌道 -->
                        <div class="wisdom-carousel-track" :style="{ transform: `translateX(-${wisdomAgriPage * 100}%)` }">
                            <div class="wisdom-carousel-page" v-for="(page, pIdx) in wisdomAgriPages" :key="pIdx">
                                <div class="wisdom-page-grid">
                                    <div
                                        v-for="(item, idx) in page"
                                        :key="idx"
                                        class="agri-result-item drop-shadow"
                                        @click="setWisdomAgriResultSelect(item)"
                                    >
                                        <!-- 相片 -->
                                        <div class="agri-result-pic">
                                            <b-img :src="item.src" fluid></b-img>
                                        </div>
                                        <!-- 標題 -->
                                        <div class="agri-result-info" style="display: flex; align-items: center; justify-content: center; min-height: 3.5rem;">
                                            <h3 class="agri-result-title">{{ item.title }}</h3>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <!-- 分頁點 -->
                        <div class="wisdom-carousel-dots" v-if="wisdomAgriPages.length > 1">
                            <span
                                v-for="(_, dIdx) in wisdomAgriPages"
                                :key="dIdx"
                                class="wisdom-dot"
                                :class="{ active: dIdx === wisdomAgriPage }"
                                @click="goToWisdomAgriPage(dIdx)"
                            ></span>
                        </div>
                    </div>
                    <!-- 資料來源網址 -->
                    <DataSource :href="wisdom_agri.source.href" :text="wisdom_agri.source.title"></DataSource>

                    <!-- 影片介紹 -->
                    <!-- 標題 -->
                    <PwaTitle :textTitle="film_introduction.title" :showMore="false"></PwaTitle>
                    <iframe style="min-height:15rem;width:100%;"  src="https://www.youtube.com/embed/AbFz1hkvEmM" title="2025 雲林縣農業處 智慧農業 加速前進" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share" referrerpolicy="strict-origin-when-cross-origin" allowfullscreen></iframe>
                    <!-- 資料來源網址 -->
                    <DataSource :href="film_introduction.source.href" :text="film_introduction.source.title"></DataSource>

                </b-container>

            </div>

            <!-- 彈出視窗(示範場域) -->
            <ModalWindow
                :show="modal.wisdom_farm.show"
                :textTitle="wisdom_farm.select.title"
                :textDescription="modal.wisdom_farm.content"
                :maxWidth="'450px'"
                @ClickClose="modal.wisdom_farm.show = false;">

                <!-- 輪播 -->
                <carousel
                    :key="wisdom_farm.select.list.length"
                    :autoplay="false"
                    :margin="10"
                    :loop="false"
                    :nav="false"
                    :dots="true"
                    :responsive="{0:{items: 1},768:{items: 1},992:{items: 1}}"
                    v-if="wisdom_farm.select.list != null && wisdom_farm.select.list.length > 0 ">

                        <div v-for="(item_farm, index_farm) in wisdom_farm.select.list" :key="index_farm">
                            <div class="agri-result-item drop-shadow">
                                <!-- 固定高度的容器 -->
                                <div class="carousel-pic">
                                    <b-img
                                    :src="'https://agri-data.kcg.gov.tw/assets/img/yun_lin/wisdom_farm/' + wisdom_farm.select.sn + '/' + item_farm.src"
                                    fluid
                                    ></b-img>
                                </div>
                            </div>
                        </div>

                </carousel>
                <div class="global-descript" style="padding-bottom: 20px;">{{ wisdom_farm.select.descript }}</div>

            </ModalWindow>

            <!-- 彈出視窗(智慧農業成果) -->
            <ModalWindow
                :show="modal.wisdom_agri.show"
                :textTitle="wisdom_agri.select.title"
                :maxWidth="'450px'"
                @ClickClose="modal.wisdom_agri.show = false;">
                <div style="min-height: 600px;max-height: 600px; overflow-y: auto;">

                    <b-img :src="wisdom_agri.select.src" style="margin-bottom: 10px;" fluid></b-img>
                    <div class="global-descript" style="margin-bottom: 10px;">
                        <span class="global-tag badge badge-primary">單位介紹</span><br />
                        <div v-html="wisdom_agri.select.unit_introduction"></div>
                    </div>
                    <div class="global-descript" style="margin-bottom: 10px;">
                        <span class="global-tag badge badge-primary">成果介紹</span><br />
                        <div v-html="wisdom_agri.select.achievement_introduction"></div>
                    </div>
                    <div style="margin-bottom: 10px;">
                        <button type="button" class="btn btn-primary btn-block" @click="setWisdomAgriResultPhotoSelect()">查看更多相片</button>
                    </div>

                </div>
            </ModalWindow>

            <!-- 彈出視窗(智慧農業成果)(圖片) -->
            <ModalWindow
                :show="modal.wisdom_agri_photo.show"
                :textTitle="wisdom_agri.select.title"
                :maxWidth="'450px'"
                @ClickClose="modal.wisdom_agri_photo.show = false;">

                <!-- 輪播 -->
                <carousel
                    :key="wisdom_agri.select.photo.length"
                    :autoplay="false"
                    :margin="10"
                    :loop="false"
                    :nav="false"
                    :dots="true"
                    :responsive="{0:{items: 1},768:{items: 1},992:{items: 1}}"
                    v-if="wisdom_agri.select.photo != null && wisdom_agri.select.photo.length > 0 ">

                        <div v-for="(item_agri_photo, index_agri_photo) in wisdom_agri.select.photo" :key="index_agri_photo">
                            <div class="agri-result-item drop-shadow">
                                <!-- 固定高度的容器 -->
                                <div class="carousel-pic">
                                    <b-img
                                    :src="'https://agri-data.kcg.gov.tw/assets/img/yun_lin/wisdom_agri_result/' + wisdom_agri.select.sn + '/' + item_agri_photo.src"
                                    fluid
                                    ></b-img>
                                </div>
                                <div class="title" style="text-align: center;">{{ item_agri_photo.title }}</div>
                            </div>
                        </div>

                </carousel>

            </ModalWindow>

        </div>

    </div>
</template>
<script>
import Header from '@/components/pwa/Header.vue'
import PwaTitle from '@/components/pwa/PwaTitle.vue'
import DataSource from '@/components/pwa/DataSource.vue'
import ModalWindow from '@/components/pwa/ModalWindow.vue'
export default {
    created() {
        window.vue = this;
        if(!window.checkLogin()){ window.setPage("login");}
    },
    components: {
        Header,
        PwaTitle,
        DataSource,
        ModalWindow
    },
    computed: {
        wisdomAgriPages() {
            const size = 6;
            const pages = [];
            for (let i = 0; i < this.wisdom_agri.list.length; i += size) {
                pages.push(this.wisdom_agri.list.slice(i, i + size));
            }
            return pages;
        }
    },
    beforeDestroy() {
        this.stopWisdomAgriAuto();
    },
    data(){
        return {
            title: "智慧農場",
            wisdomAgriPage: 0,
            wisdomAgriTimer: null,
            agriTouchStartX: 0,
            //示範場域
            wisdom_farm:{
                title:"示範場域",
                list:[],
                select:[],
                //查看更多
                more:true,
                source:{
                    title:"雲林農業處",
                    href:"https://agriculture.yunlin.gov.tw/"
                },
            },

            //智慧農業成果
            wisdom_agri:{
                title:"智慧農業成果",
                list:[],
                select:[],
                //查看更多
                more:true,
                source:{
                    title:"雲林農業處",
                    href:"https://agriculture.yunlin.gov.tw/"
                },
            },

            //影片介紹
            film_introduction:{
                title:"影片介紹",
                list:[],
                select:[],
                //查看更多
                more:true,
                source:{
                    title:"雲林農業處",
                    href:"https://agriculture.yunlin.gov.tw/"
                },
            },

            //彈出視窗
            modal:{

                //示範場域
                wisdom_farm:{
                    //是否呈現
                    show:false,
                    //標題
                    title:"智慧農場描述",
                    //內容
                    content:"",
                    //時間
                    time:"",
                },

                //智慧農業成果
                wisdom_agri:{
                    //是否呈現
                    show:false,
                    title:"智慧農業成果",
                },

                //智慧農業成果(圖片)
                wisdom_agri_photo:{
                    //是否呈現
                    show:false,
                    title:"智慧農業成果",
                },

            },

            //api 取得智慧農場
            apiGetWisdomFarm: (data) => this.userRequest.get("/API/Default/GetWisdomFarm", data),

            //api 取得智慧農業成果
            apiGetWisdomAgriResult: (data) => this.userRequest.get("/API/Default/GetWisdomAgriResult", data),
        }
    },
    mounted() {

        this.getWisdomFarm();
        this.getWisdomAgriResult();
        this.getFilmIntroduction();

    },
    methods: {

        //取得示範場域
        getWisdomFarm:function()
        {
            this.soil = [];
            this.apiGetWisdomFarm({

            })
            .then((res)=>{

                const data = JSON.parse(res.data);
                const list = data.list;
                console.log(list);
                this.wisdom_farm.list = [];
                for(var i=0;i < list.length ; i++){

                    var item = list[i];
                    this.wisdom_farm.list.push({
                        title:item.name,
                        src:'https://agri-data.kcg.gov.tw/assets/img/yun_lin/wisdom_farm/' + item.sn + '/' + item.cover,
                        url:'FarmDetail/' + item.sn,
                        descript:item.descript,
                        device_id:item.device_id,
                        list:item.list,
                        sn:item.sn
                    });
                    console.log(item.name);
                }

            })
            .catch((err)=> {
                console.log(err);
                this.disableMask();
            });

        },

        //取得智慧農業成果
        getWisdomAgriResult:function()
        {
            this.apiGetWisdomAgriResult({

            })
            .then((res)=>{

                const data = JSON.parse(res.data);
                const list = data.list;
                console.log(list);
                this.wisdom_agri.list = [];

                for(var i=0; i<list.length ; i++)
                {
                    var item = list[i];
                    this.wisdom_agri.list.push({

                        src:"https://agri-data.kcg.gov.tw/assets/img/yun_lin/wisdom_agri_result/" + item.sn + "/" + item.cover,
                        sn:item.sn,
                        title:item.name,
                        year:item.year,
                        benefit:item.save_labour,
                        target:item.question,
                        strategy:item.solution,
                        city:item.town,
                        unit_introduction:item.unit_introduction,
                        achievement_introduction:item.achievement_introduction,
                        photo:item.photo,
                    });
                }

                this.$nextTick(() => { this.startWisdomAgriAuto(); });

            })
            .catch((err)=> {
                console.log(err);
                this.disableMask();
            });
        },

        //取得youtube影片連結
        getFilmIntroduction:function(){

            this.film_introduction.list.push({src:"https://www.youtube.com/embed/gcnmmqqH21s?si=HfI-kGaiu90iLSnq"});
        },

        //設定示範場域(已選擇)
        setWisdomFarmSelect(select) {

            this.wisdom_farm.select = select;
            this.modal.wisdom_farm.show = true;
        },

        //設定智慧農業成果(已選擇)
        setWisdomAgriResultSelect(select) {

            this.wisdom_agri.select = select;
            this.modal.wisdom_agri.show = true;
        },

        //智慧農業成果(圖片)(已選擇)
        setWisdomAgriResultPhotoSelect() {

            this.modal.wisdom_agri_photo.show = true;
        },

        startWisdomAgriAuto() {
            this.wisdomAgriTimer = setInterval(() => {
                const next = this.wisdomAgriPage + 1;
                this.wisdomAgriPage = next >= this.wisdomAgriPages.length ? 0 : next;
            }, 3000);
        },

        stopWisdomAgriAuto() {
            if (this.wisdomAgriTimer) {
                clearInterval(this.wisdomAgriTimer);
                this.wisdomAgriTimer = null;
            }
        },

        goToWisdomAgriPage(idx) {
            this.wisdomAgriPage = idx;
            this.stopWisdomAgriAuto();
            this.startWisdomAgriAuto();
        },

        onAgriMouseDown(e) {
            this.agriTouchStartX = e.clientX;
        },

        onAgriMouseUp(e) {
            const delta = e.clientX - this.agriTouchStartX;
            if (Math.abs(delta) < 50) return;
            if (delta < 0) {
                const next = this.wisdomAgriPage + 1;
                this.wisdomAgriPage = next >= this.wisdomAgriPages.length ? 0 : next;
            } else {
                const prev = this.wisdomAgriPage - 1;
                this.wisdomAgriPage = prev < 0 ? this.wisdomAgriPages.length - 1 : prev;
            }
            this.stopWisdomAgriAuto();
            this.startWisdomAgriAuto();
        },

        onAgriTouchStart(e) {
            this.agriTouchStartX = e.touches[0].clientX;
        },

        onAgriTouchEnd(e) {
            const delta = e.changedTouches[0].clientX - this.agriTouchStartX;
            if (Math.abs(delta) < 50) return;
            if (delta < 0) {
                const next = this.wisdomAgriPage + 1;
                this.wisdomAgriPage = next >= this.wisdomAgriPages.length ? 0 : next;
            } else {
                const prev = this.wisdomAgriPage - 1;
                this.wisdomAgriPage = prev < 0 ? this.wisdomAgriPages.length - 1 : prev;
            }
            this.stopWisdomAgriAuto();
            this.startWisdomAgriAuto();
        }
    }
}
</script>

<style scoped>
/* 輪播外框：裁切溢出 */
.wisdom-carousel {
    overflow: hidden;
    position: relative;
    user-select: none;
    cursor: grab;
}

/* 滑動軌道：水平並排所有分頁，CSS transition 產生換頁動畫 */
.wisdom-carousel-track {
    display: flex;
    transition: transform 0.5s ease;
}

/* 每一頁佔滿外框寬度 */
.wisdom-carousel-page {
    min-width: 100%;
    box-sizing: border-box;
}

/* 每頁內部：3 欄 × 2 列網格 */
.wisdom-page-grid {
    display: grid;
    grid-template-columns: repeat(3, 1fr);
    gap: 8px;
}

/* 分頁點列 */
.wisdom-carousel-dots {
    display: flex;
    justify-content: center;
    gap: 6px;
    margin-top: 8px;
}

/* 分頁點 */
.wisdom-dot {
    display: inline-block;
    width: 6px;
    height: 6px;
    border-radius: 50%;
    background: #ccc;
    cursor: pointer;
    transition: background 0.3s;
}
.wisdom-dot.active {
    background: #4a90d9;
}
</style>
